import React, {Suspense}  from 'react';
import {BrowserRouter as Router} from 'react-router-dom'
import './App.css';
import {ConfigProvider, Layout} from "antd";
import byBY from 'antd/lib/locale/by_BY'
import ruRU from 'antd/lib/locale/ru_RU'
import Header from "./containers/Menu/Header";
import Footer from "./containers/Menu/Footer";
import Routes from './routes'
import GlobalLoading from "./components/Loading/Global";
import {useSelector} from "react-redux";

function App() {
    const {isGlobalLoading, isRu} = useSelector((state: any) => state.globalReducer)
    return (
        <Router>
            <ConfigProvider 
                select={{className: "select_ao"}}
                locale={isRu ? ruRU : byBY}
             >
                <Layout className="main-root-layout-ps">
                    <Suspense fallback={<GlobalLoading/>}>
                        <Header/>
                        <Layout.Content className="layout-content">
                            <Routes/>
                            {isGlobalLoading && <GlobalLoading/>}
                        </Layout.Content>
                        <Footer/>
                    </Suspense>
                </Layout>
            </ConfigProvider>
        </Router>
    );
}

export default App;
